module.exports = __webpack_public_path__ + "static/media/signin-img.6e124334.png";